module.exports = __webpack_public_path__ + "res/Roboto-Light-webfont.svg?ba8c3479037a6b0f65a1f93d1df8193d";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Light-webfont.svg
// module id = 65
// module chunks = 0